import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Modal from "../Modal/Modal";
import { Typography, Button } from "@mui/material";

export default function EnrollOnInactiveModalDialog(props) {
  const { t } = useTranslation();
  const { isIlt, isMultiversioned, open, onClose } = props;
  const versionCaption = t(
    `courses.versionInactivated.name.${isIlt ? "ilt" : "online"}`
  );

  return (
    <Modal
      data-qa="enroll-on-inactive-version-dialog"
      dialogTitle={
        <Typography variant="h4" color="textPrimary">
          {t("courses.versionInactivated.title", { name: versionCaption })}
        </Typography>
      }
      dialogContent={
        <Typography>
          {isMultiversioned === null
            ? t("courses.versionInactivated.undefinedText", {
                name: versionCaption
              })
            : isMultiversioned
            ? t("courses.versionInactivated.text", { name: versionCaption })
            : t(
                `courses.chooseVersionModal.noActiveVersions.${
                  isIlt ? "ilt" : "online"
                }`
              )}
        </Typography>
      }
      dialogActions={
        <Button color="primary" onClick={onClose}>
          {t("closeBtn")}
        </Button>
      }
      showCloseIcon
      open={open}
      onClose={onClose}
      maxWidth="md"
      scrollable
    />
  );
}

EnrollOnInactiveModalDialog.propTypes = {
  isIlt: PropTypes.bool,
  isMultiversioned: PropTypes.bool,
  open: PropTypes.bool,
  onClose: PropTypes.func
};
